import Head from 'next/head';

import Layout from '@/features/layout';
import StartAppsSection from '@/features/homepage/start-section';
import AppsClosed from '@/features/homepage/apps-closed';
import ContactOptions from '@/features/contact-options';
import { getSiteSettings } from 'modules/site-settings';
import {
	defaultClosedMessage,
	formatDisplayDate
} from 'modules/site-settings/format';

export default function Home({ settings }) {
	return (
		<div className="" data-sentry-component="Home" data-sentry-source-file="index.jsx">
			<Head data-sentry-element="Head" data-sentry-source-file="index.jsx">
				<title>Elf Fund Application</title>
				<meta
					name="description"
					content="Elf Fund App - Supporting the Bradford Community since 1983"
				data-sentry-element="meta" data-sentry-source-file="index.jsx" />
				<link rel="icon" href="/favicon.ico" />
			</Head>
			<Layout data-sentry-element="Layout" data-sentry-source-file="index.jsx">
				<section className="h-full">
					{settings.applicationsOpen ? (
						<>
							<h1 className="text-center mt-8 text-5xl px-4 font-bold">
								{settings.year} Elf Fund
							</h1>
							<p className="text-center text-xl mt-4 px-4">
								Accepting applications{' '}
								<span className="inline-block">
									{formatDisplayDate(settings.openDate)} -{' '}
									{formatDisplayDate(settings.closeDate)},{' '}
									{settings.year}
								</span>
							</p>
							<StartAppsSection />
						</>
					) : (
						<AppsClosed
							year={settings.year}
							message={
								settings.closedMessage ||
								defaultClosedMessage(settings.decisionDate)
							}
						/>
					)}
					<ContactOptions data-sentry-element="ContactOptions" data-sentry-source-file="index.jsx" />
				</section>
			</Layout>
		</div>
	);
}

export async function getServerSideProps() {
	return {
		props: { settings: await getSiteSettings() }
	};
}
